import { ErrorReportingUtils, GoogleAPI, PAP } from '@mm/plugins';
import store from '@mm/state/store';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import 'focus-visible';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { render } from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import 'whatwg-fetch';
import { ContextStore } from './common/components/ConnectedPopover/ConnectedPopover';
import { PAGE_VIEW } from './common/helpers/plugins/constants';
import {
  initFacebookPixel,
  trackFacebookEvent,
} from './common/helpers/plugins/facebook-pixel-init';
import { initOneSignal } from './common/helpers/plugins/onesignal-init';
import { initWebsiteGoogleAnalytics } from './common/helpers/plugins/website-google-analytics';
import { initXstateInspect } from './common/helpers/plugins/xstate-inspector';
import { initXrayScript } from './common/helpers/plugins/xray-script-init';
import './common/scss/style.scss';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './i18n';
import Main from './Main';
import { Routes } from './routes/top-level-routes'; // Our custom react component
// Our custom react component

// Activate Sentry before everything else to catch errors
ErrorReportingUtils.initialize(
  'https://d50a6107ab8146d6be5ff264f7d5d098@sentry.io/1211326',
  { attachStacktrace: true },
);

setTimeout(() => {
  initWebsiteGoogleAnalytics();
  initFacebookPixel();
  trackFacebookEvent(PAGE_VIEW);
  initOneSignal();
  PAP.init();
  GoogleAPI.init();
  initXrayScript();
}, 50);
ContextStore.setStore(store);
initXstateInspect();

const locale = (navigator && navigator.language) || 'en-US';
// Render the main app react component into the app div.
// For more details see: https://facebook.github.io/react/docs/top-level-api.html#react.render
render(
  <Provider store={store as any}>
    <CookiesProvider>
      <IntlProvider locale={locale}>
        <BrowserRouter>
          <Switch>
            <Route
              path={Routes.invite.path}
              component={Routes.invite.component}
            />
            <Route component={Main} />
          </Switch>
        </BrowserRouter>
      </IntlProvider>
    </CookiesProvider>
  </Provider>,

  document.getElementById('app-container'),
);
